import { Component, OnInit, AfterViewInit, Input, ViewChild } from '@angular/core';
import { InterviewStreamService } from '../student/interview/services/interview.service';

@Component({
    selector: 'video-stream',
    templateUrl: './stream.component.html',
    standalone: false
})
export class StreamComponent implements AfterViewInit {

    @ViewChild('stream', {static: false}) stream: any;

    constructor(private _videoService:InterviewStreamService){}

    ngAfterViewInit() {
        this._videoService.videoconnect(this.stream.nativeElement);
        this._videoService.currentStream.subscribe(video => {
            this.stream = video;
        });
    }
}
